import type { EditorPlatformApp } from '../../types/editor';
import { createPrivateAPI } from './api-exports/private-api';
import { createPublicAPI } from './api-exports/public-api';
import { getAppManifest } from './app-manifest';
import { editorReady } from './editor-ready';

export { shouldUseSplitPlatformApp } from './utils';

export const splitApp: EditorPlatformApp = {
  editorReady,
  getAppManifest,
  exports: {
    public: createPublicAPI,
    private: createPrivateAPI,
  },
};
